import React from 'react';
export const Footer = () => {
  return <footer className="bg-ink py-12 px-[5vw]" data-id="element-297">
      <div className="max-w-6xl mx-auto flex flex-col items-center" data-id="element-298">
        <div className="flex flex-wrap justify-center gap-6 md:gap-10 mb-10" data-id="element-299">
          <a href="/termos" className="text-white/70 hover:text-gold transition-colors text-sm font-medium" data-id="element-300">
            Termos de uso
          </a>
          <a href="/privacidade" className="text-white/70 hover:text-gold transition-colors text-sm font-medium" data-id="element-301">
            Política de privacidade
          </a>
          <a href="https://app.myaurora.com.br/" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-gold transition-colors text-sm font-medium" data-id="element-302">
            Login
          </a>
        </div>

        <div className="text-center" data-id="element-303">
          <p className="text-white/50 text-sm mb-2" data-id="element-304">
            © 2026 Aurora Precificador
          </p>
          <p className="text-white/50 text-sm flex items-center justify-center gap-1.5" data-id="element-305">
            Feito com <span data-id="element-306">🌸</span> para artesãs brasileiras
          </p>
        </div>
      </div>
    </footer>;
};